import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    campaign_beginDate: null,
    campaign_lastDate: null,
    campaign_datasets: [],
    positiveandnagative_v1: [],
    positiveandnagative_v2: [],
    categories_filter: null,
    //v2
    campaign_isLoading: false,
    campaign_sentiment: {},
    campaign_sentiment_x_date: {},
    campaign_categories: {},
    active_params: null,
    campaign_categories_selected: null,
}

// getters
const getters = {
    campaign_date: state => {
        if (state.campaign_beginDate != null) {
            var _start = state.campaign_beginDate.split("T");
            var _end = state.campaign_lastDate.split("T")
            return { start: _start[0], end: _end[0] }
        } else {
            return { start: state.campaign_beginDate, end: state.campaign_lastDate }
        }
    },
    campaign_isLoading: state => {
        return state.campaign_isLoading;
    },
    campaign_data_date: state => {
        if (state.campaign_beginDate !== null) {
            var _start = state.campaign_beginDate.split("T");
            var _end = state.campaign_lastDate.split("T")
            return _start[0] + " to " + _end[0];
        }else{
            return "N/A"
        }          
    },
    campaign_datasets: state => {
        return state.campaign_datasets;
    },
    positiveandnagative_v1: state => {
        return state.positiveandnagative_v1;
    },
    positiveandnagative_v2: state => {
        return state.positiveandnagative_v2;
    },
    campaign_categories: state => {
        var items = [];
        if (state.campaign_categories.rows != undefined) {
            state.campaign_categories.rows.forEach(function(item, index) {
                items.push(item._id.campaign_categories);
            });
            items.sort(function(a, b) {
                return a.localeCompare(b);
            });
        }
        return items;
    },
    categories_filter: state => {
        return state.categories_filter;
    },
    campaign_categories_selected: state => {
        return state.campaign_categories_selected;
    }
}

// actions
const actions = {
    // start /v2 actions
    V2getCampaignDatasets(context, payload) {
        state.campaign_isLoading = true;
        state.categories_filter = null;
        var _params = {};
        // calulate _params from main_filters
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination != null) {
                _params.location_destination = main_filters.location_destination;
            }
        }
        // calucate _params from sub_filters
        var sub_filter = payload.sub_filter;
        if (sub_filter !== null) {
            if (sub_filter.campaign_categories !== null) {
                _params.campaign_categories = sub_filter.campaign_categories;
                state.campaign_categories_selected = sub_filter.campaign_categories
            } else {
                state.campaign_categories_selected = null
            }
        } else {
            state.campaign_categories_selected = null
        }

        const request = {
            params: qs.parse(_params)
        };

        //query data
        instance.get('v2/tourist/campaign', request)
            .then(response => {
                const {
                    date,
                    campaign_sentiment,
                    campaign_sentiment_x_date,
                    campaign_categories
                } = response.data;

                state.campaign_beginDate = date.start;
                state.campaign_lastDate = date.end;
                state.campaign_sentiment = campaign_sentiment;
                state.campaign_sentiment_x_date = campaign_sentiment_x_date;
                state.campaign_categories = campaign_categories;

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "positiveandnegative_v1") {
                        context.commit("V2onPositiveAndNagativeV1", payload);
                    } else if (stateName == "positiveandnegative_v2") {
                        context.commit("V2onPositiveAndNagativeV2", payload);
                    }
                })
                state.campaign_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/v2/tourist/campaign] syntax errors under instant.get");
            })
    },

    V2getCategoriesFilter(context, payload) {        
        if (payload.sub_filter.campaign_categories !== undefined) {
            context.dispatch("V2getCampaignDatasets", { "main_filters": payload.main_filters, "sub_filter": payload.sub_filter, "stateDatasets": ['positiveandnegative_v1', 'positiveandnegative_v2'] });
        }
    },

    getCampaignDatasets(context, payload) {
        console.log("[store/tourist/campaign] getCampaignDatasets() DEPRECATED");
        return;
    },

    getCategoriesFilter(context, payload) {
        console.log("[store/tourist/campaign] getCategoriesFilter() DEPRECATED");
        return;
    }
}

// mutations
const mutations = {
    V2onPositiveAndNagativeV1(state, payload) {
        // --- start dataset doughnut for chart
        // items = [{data:0,label:'label'}]
        var colors = [];
        colors['positive'] = '#3241a6';
        colors['neutral'] = '#578e47';
        colors['negative'] = '#cf9a41';

        var rows = state.campaign_sentiment.rows;
        var total = 0;
        var items = [];
        for (var key in colors) {
            items.push({ color: colors[key], data: 0, "label": key.toUpperCase() });
        }

        rows.forEach(function(item, index) {
            total += item.sum_contact;

            var _color = "#e5e5e5";
            if (colors[item._id.campaign_sentiment] !== undefined) {
                _color = colors[item._id.campaign_sentiment];
            }
            var label = item._id.campaign_sentiment.toUpperCase();
            var _item = { "data": item.sum_contact, "label": label, color: _color };

            // sort by user defined - colors array
            var _index = 0;
            for (var key in colors) {
                if (key == item._id.campaign_sentiment) {
                    items[_index] = _item;
                }
                _index++;
            }
        });
        // check total
        if (total == 0) {
            items = [];
        }
        state.positiveandnagative_v1 = items
        // --- end dataset for doughnut chart
    },
    V2onPositiveAndNagativeV2(state, payload) {
        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]
        var total = 0;
        var colors = [];
        colors['POSITIVE'] = '#3241a6';
        colors['NEUTRAL'] = '#578e47';
        colors['NEGATIVE'] = '#cf9a41';

        var rows = state.campaign_sentiment_x_date.rows;
        var items = [];
        rows.forEach(function(item, index) {
            total += item.sum_contact;
            var _item = {};
            var _campaign_sentiment = item._id.campaign_sentiment.toUpperCase();
            var pos = items.map(function(e) {
                return e.date;
            }).indexOf(item._id.date);
            if (pos == -1) {
                _item['date'] = item._id.date;
                _item['POSITIVE'] = 0;
                _item['NEUTRAL'] = 0;
                _item['NEGATIVE'] = 0;
                _item[_campaign_sentiment] = item.sum_contact;
                items.push(_item);
            } else {
                _item = items[pos];
                if (_item[_campaign_sentiment] != undefined) {
                    _item[_campaign_sentiment] += item.sum_contact;
                } else {
                    _item[_campaign_sentiment] = item.sum_contact;
                }
                items[pos] = _item;
            }
        });

        // sort by date desc        
        items.sort(function(a, b) {
            var _a = parseInt(a.date.split("-").join(""));
            var _b = parseInt(b.date.split("-").join(""));
            return _a - _b;
        });

        // attached colors 
        items.push(colors);

        if (total == 0) {
            items = [];
        }
        state.positiveandnagative_v2 = items
        // --- end dataset for stack chart
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}